
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import Resumecontent from "./ResumeContent";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";

import pdf from "../../Assets/AM.pdf";

function Resume() {
  
 
 

 

  return (
    <Container fluid className="resume-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button variant="primary" href={pdf} target="_blank">
            <i className="fas fa-download">&nbsp;</i>Download CV
          </Button>
        </Row>
        <Row className="resume">
          <Col md={6} className="resume-left">
            <h3 className="resume-title">Experience</h3>
            <Resumecontent
              title="Jt.Tech Head"
              date="July 2022 - Present"
              content={[
                "Joint Tech Head Of CSI SFIT.",
                "I had the opportunity to showcase my strong leadership and teamwork skills in the design and management of technical events for members, as well as mentoring engineers in the development of promotional content for all events, workshops, and seminars conducted by CSI SFIT. Through my efforts, I successfully developed and executed technical events that provided valuable learning experiences for members, contributing to the development of a skilled and engaged community of professionals.Furthermore, I played a pivotal role in mentoring engineers in the development of high-quality promotional content, providing guidance and support to ensure that all materials were engaging and effective in communicating the value of events to participants. As a result, I was able to work collaboratively with team members, closely collaborating with other leaders and stakeholders to ensure that all technical events were executed seamlessly and achieved their goals.Overall, my experience in this role allowed me to showcase my abilities as a leader and a team player, working closely with others to deliver exceptional technical events and ensuring that all members of the community felt engaged and valued. I look forward to applying these skills in future roles and continuing to make a positive impact on the organizations I work with." 
              ]}
            />
    
            <Resumecontent
              title="Web Development Engineers"
              date="August 2020 - December 2021"
              content={[
                "Web developer Engineer at Static.Int Educare.",
                "Diagnosed and resolved software issues by troubleshooting and debugging code, ensuring compatibility with a wide range of devices, browsers, and operating systems.Designed and developed engaging user interfaces with modern JavaScript frameworks, HTML5, and CSS3, enhancing the user experience and driving engagement.Maintained the highest level of quality assurance through comprehensive code testing and cross-browser testing, resulting in a seamless and bug-free user experience.Researched and developed innovative new technology designs, implementing cutting-edge solutions to complex software challenges, and staying up-to-date with the latest industry trends and best practices."
              ]}
            />
      
               <Resumecontent
              title="Summer Intern"
              date="June 2020 - July 2020"
              content={[
                "Web developer intern at Static.Int Educare.",
               "Committed to ongoing learning and development, attended numerous corporate training programs to acquire new competencies and enhance professional skills.Leveraged scripting languages, content creation tools, management tools, and digital media to design innovative and engaging websites, contributing to the development of high-quality and visually appealing web solutions.Proactively sought out opportunities to expand knowledge and skills, staying up-to-date with the latest industry trends and best practices, and continuously improving the quality of work.Passionate about achieving the highest level of excellence in every project, focused on delivering solutions that exceed expectations and contribute to the success of the organization.",
              ]}
            />
            <h3 className="resume-title">Extracurricular Activities</h3>
         
            <Resumecontent
              title="Web design/coding club"
              content={["Was in a Web designing club in 2019",]}
              
            />
             <Resumecontent
              title="Robotics Club"
              content={[
                "robotics club -2017",
              ]}
            />
              <Resumecontent
              title=" Video Game Development"
              content={[
                "Learned many technologies such C#,Unity 3D & Python",
              ]}
            />
            <Resumecontent
              title=" State Cricket Championship"
              content={[
                "Runner- up  ",
              ]}
            />
            <Resumecontent
              title=" School Volleyball Team (2014-2016)"
              content={[
                "Was Hard-hitter and helped my team to two 4th place finishes in the State Tournament and won one Special District Championships.",
              ]}
            />



          </Col>
          <Col md={6} className="resume-right">
            <h3 className="resume-title">Education</h3>
            <Resumecontent
              title=" Electronics and Telecommunication Engineering[St. Francis Institute of Technology Mumbai, Maharashtra] "
              date="2021 - Present"
              content={[`9.91 CGPI`]}
            />

            <Resumecontent
              title="Computer Science Enginnering[Thakur Polytechnic in Mumbai, Maharashtra] "
              date="2018 - 2021"
              content={[`8.9 SGPI`]}
            />
            
            <Resumecontent
              title="10TH BOARD [Thakur Vidya Mandir High School,Mumbai] "
              content={["Grade:A"]}
            />
            
          </Col>
        </Row>
        
      </Container>
    </Container>
  );
}

export default Resume;
